import { ref } from "vue";
import { open as openDialogCoordinator } from "@/services/ui/DialogCoordinator.js";
import * as Util from "@utils/Util.js";

export function useDialogs() {
  const opendialogRef = ref(null);
  const savedialogRef = ref(null);
  const optionsdialogRef = ref(null);
  const sharedialogRef = ref(null);
  const sheetdialogRef = ref(null);
  const accountdialogRef = ref(null);
  const winnerdialogRef = ref(null);
  const titleAndDescriptionDialogRef = ref(null);
  const themedialogRef = ref(null);

  function openOpenDialog() {
    Util.trackEvent("Wheel", "ShowOpenDialog", "");
    openDialogCoordinator("open");
    opendialogRef.value?.show();
  }

  function openSaveDialog() {
    Util.trackEvent("Wheel", "ShowSaveDialog", "");
    openDialogCoordinator("save");
    savedialogRef.value?.show();
  }

  function openShareDialog() {
    Util.trackEvent("Wheel", "GetSharableLink", "");
    openDialogCoordinator("share");
    sharedialogRef.value?.show();
  }

  function openCustomizeDialog() {
    Util.trackEvent("Wheel", "ShowCustomizeDialog", "");
    openDialogCoordinator("options");
    optionsdialogRef.value?.show();
  }

  function openSheetDialog() {
    Util.trackEvent("Wheel", "ShowSpreadsheetDialog", "");
    openDialogCoordinator("sheet");
    sheetdialogRef.value?.show();
  }

  function openAccountDialog() {
    Util.trackEvent("Wheel", "ShowAccountDialog", "");
    openDialogCoordinator("account");
    accountdialogRef.value?.show();
  }

  function openThemeDialog() {
    Util.trackEvent("Wheel", "ShowThemeDialog", "");
    openDialogCoordinator("theme");
    themedialogRef.value?.show();
  }

  function openTitleAndDescriptionDialog() {
    titleAndDescriptionDialogRef.value?.show();
  }

  return {
    opendialogRef,
    savedialogRef,
    optionsdialogRef,
    sharedialogRef,
    sheetdialogRef,
    accountdialogRef,
    winnerdialogRef,
    titleAndDescriptionDialogRef,
    themedialogRef,
    openOpenDialog,
    openSaveDialog,
    openShareDialog,
    openCustomizeDialog,
    openSheetDialog,
    openAccountDialog,
    openThemeDialog,
    openTitleAndDescriptionDialog,
  };
}
